module.exports = {"150105001":"人民路街道","150105002":"大学西路街道","150105003":"乌兰察布东路街道","150105004":"大学东路街道","150105005":"中专路街道","150105006":"昭乌达路街道","150105007":"巴彦街道","150105008":"敕勒川路街道","150105101":"榆林镇","150105103":"黄合少镇","150105104":"金河镇","150105400":"金桥经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150105.json
// module id = 394
// module chunks = 0